module.exports = __webpack_public_path__ + "static/media/menu-landing-pages-facebook.f5cdf4d5.svg";